import React, { useState } from 'react';
import loginIcons from '../assets/signin.gif';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AdminLogin = () => {
    const [showPassword, setShowPassword] = useState(false);
    const [data, setData] = useState({
        username: "",
        password: ""
    });

    const navigate = useNavigate();

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const STATIC_ADMIN_USERNAME = "admin";
        const STATIC_ADMIN_PASSWORD = "admin123";
        const STATIC_ADMIN_ID = "12345";

        if (data.username === STATIC_ADMIN_USERNAME && data.password === STATIC_ADMIN_PASSWORD) {
            toast.success("Admin login successful");

            sessionStorage.setItem(
                "H7Z4L9VD2XK5JW8QRYT6",
                btoa(STATIC_ADMIN_ID)
            );

            navigate("/admin-panel/dashboard");
        } else {
            toast.error("Invalid username or password");
        }
    };

    return (
        <section id="login" className="min-h-screen bg-gradient-to-b from-pink-50 via-pink-100 to-pink-200 flex items-center justify-center py-8 px-4">
            {/* Increased width: max-w-lg instead of max-w-sm */}
            <div className="w-full max-w-lg mx-auto">
                <div className="bg-white shadow-xl rounded-2xl p-6 sm:p-8 border border-pink-100">
                    {/* Compact EVEYA Branding */}
                    <div className="text-center mb-6">
                        <h1 className="text-4xl font-extrabold text-pink-700 tracking-wide">
                            EVEYA
                        </h1>
                        <p className="text-pink-600 text-base font-medium mt-2">
                            Admin Portal
                        </p>
                        <div className="w-24 h-px bg-gradient-to-r from-transparent via-pink-300 to-transparent mx-auto mt-3"></div>
                    </div>

                    {/* Smaller Login Illustration */}
                    <div className="w-24 h-24 mx-auto mb-6 rounded-full overflow-hidden border-6 border-pink-100 shadow-lg">
                        <img 
                            src={loginIcons} 
                            alt="Login illustration" 
                            className="w-full h-full object-cover"
                        />
                    </div>

                    <form className="space-y-5" onSubmit={handleSubmit}>
                        {/* Username Field */}
                        <div>
                            <label className="block text-pink-800 font-semibold text-base mb-1.5">
                                Username
                            </label>
                            <input
                                type="text"
                                placeholder="Enter username"
                                name="username"
                                value={data.username}
                                onChange={handleOnChange}
                                className="w-full px-4 py-3 rounded-xl border-2 border-pink-200 focus:border-pink-500 focus:outline-none transition-all bg-pink-50/50 placeholder-pink-400 text-gray-800"
                                required
                                autoComplete="username"
                            />
                        </div>

                        {/* Password Field */}
                        <div>
                            <label className="block text-pink-800 font-semibold text-base mb-1.5">
                                Password
                            </label>
                            <div className="relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    placeholder="Enter password"
                                    name="password"
                                    value={data.password}
                                    onChange={handleOnChange}
                                    className="w-full px-4 py-3 rounded-xl border-2 border-pink-200 focus:border-pink-500 focus:outline-none transition-all bg-pink-50/50 placeholder-pink-400 text-gray-800 pr-12"
                                    required
                                    autoComplete="current-password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(prev => !prev)}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 text-pink-600 hover:text-pink-700 text-xl transition"
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </button>
                            </div>

                            <Link
                                to="/forgot-password"
                                className="block text-right mt-2 text-pink-600 hover:text-pink-700 font-medium text-sm underline-offset-2 hover:underline transition"
                            >
                                Forgot password?
                            </Link>
                        </div>

                        {/* Login Button with ONLY Secure Lock Icon (No Text) */}
                        <div className="pt-2">
                            <button
                                type="submit"
                                className="w-full bg-gradient-to-r from-pink-600 to-pink-700 hover:from-pink-700 hover:to-pink-800 text-white font-bold py-4 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-300 flex items-center justify-center"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="w-6 h-6"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    strokeWidth={2.5}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                                    />
                                </svg> LOGIN 
                            </button>
                        </div>
                    </form>

                    {/* Compact Footer */}
                    <div className="text-center mt-8">
                        <p className="text-pink-700 font-medium text-sm">
                            Welcome back to <span className="font-bold">EVEYA</span> Admin
                        </p>
                        <p className="text-pink-500 text-xs mt-2">
                            © 2026 EVEYA Beauty
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AdminLogin;